export default __webpack_public_path__ + "static/media/week1.d3ac5818.png";